export default "__VITE_ASSET__BjMcBsns__"